/* SOLIT Black Friday landing page
   1. Countdown: elk element met data-bf-countdown="2026-11-16T00:00:00+01:00"
   2. Popup: elk element met data-bf-popup="KLAVIYO_FORM_ID" opent die Klaviyo popup
   3. Tracking: Meta Lead event bij een Klaviyo submit op deze pagina */
(function () {
  if (window.__bfLanding) return;
  window.__bfLanding = true;

  // 1. Countdown
  function pad(n) { return String(n).padStart(2, '0'); }
  function tick() {
    document.querySelectorAll('[data-bf-countdown]').forEach(function (el) {
      var target = new Date(el.getAttribute('data-bf-countdown')).getTime();
      var t = Math.max(0, target - Date.now());
      var set = function (unit, val) {
        var n = el.querySelector('[data-unit="' + unit + '"]');
        if (n) n.textContent = pad(val);
      };
      set('d', Math.floor(t / 86400000));
      set('h', Math.floor(t / 3600000) % 24);
      set('m', Math.floor(t / 60000) % 60);
      set('s', Math.floor(t / 1000) % 60);
    });
  }
  tick();
  setInterval(tick, 1000);

  // 2. Klaviyo popup op klik
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-bf-popup]');
    if (!trigger) return;
    var formId = trigger.getAttribute('data-bf-popup');
    if (!formId) return; // geen form ID ingevuld: link werkt gewoon als anker
    e.preventDefault();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  });

  // 3. Meta Lead event, alleen voor de BF forms
  var bfForms = (document.querySelector('[data-bf-forms]') || { dataset: {} }).dataset.bfForms;
  var allowed = (bfForms || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  window.addEventListener('klaviyoForms', function (e) {
    if (!e.detail || e.detail.type !== 'submit') return;
    if (allowed.length && allowed.indexOf(e.detail.formId) === -1) return;
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'Lead', { content_name: 'BF 2026 lijst', form_id: e.detail.formId });
    }
  });
})();
